var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStationSubwayWaltti = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 3.5A3.5 3.5 0 0 1 3.5 0h21A3.5 3.5 0 0 1 28 3.5v21a3.5 3.5 0 0 1-3.5 3.5h-21A3.5 3.5 0 0 1 0 24.5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M20.057 10.862v-.596c0-.035.07-.07.139-.07V24.5H24.5v-21h-6.352l-3.992 14.339-.07.982h-.103l-.104-.982L9.887 3.5H3.5v21h4.374V10.196c.034 0 .104.035.104.07v.596L11.865 24.5h4.27z",
  clipRule: "evenodd"
})));
export { SvgStationSubwayWaltti as ReactComponent };